import { API_TARGET_AUTH } from 'lib/auth';

const authRoutes = {
  createAuthSession: {
    apiTarget: API_TARGET_AUTH,
    url: '/sessions',
    method: 'post',
    reducer: {
      name: 'tenant',
      type: 'updateTenant',
      initialState: {}
    }
  },

  deleteAuthSession: {
    apiTarget: API_TARGET_AUTH,
    url: '/sessions',
    method: 'delete',
    reducer: {
      name: 'tenant',
      type: 'updateTenant',
      initialState: {}
    }
  },

  fetchRoles: {
    apiTarget: API_TARGET_AUTH,
    url: '/sites/:site_id/permission_roles',
    reducer: {
      name: 'roles',
      initialState: {}
    }
  },

  fetchRoleById: {
    apiTarget: API_TARGET_AUTH,
    url: '/sites/:site_id/permission_roles/:permission_role_id',
    reducer: {
      name: 'role',
      initialState: {}
    }
  },

  createRole: {
    apiTarget: API_TARGET_AUTH,
    url: '/sites/:site_id/permission_roles',
    method: 'post'
  },

  editRole: {
    apiTarget: API_TARGET_AUTH,
    url: '/sites/:site_id/permission_roles/:permission_role_id',
    method: 'patch'
  },

  deleteRole: {
    apiTarget: API_TARGET_AUTH,
    url: '/sites/:site_id/permission_roles/:permission_role_id',
    method: 'delete'
  },

  assignStaffToRole: {
    apiTarget: API_TARGET_AUTH,
    url: '/sites/:site_id/permission_roles/:permission_role_id/assign',
    method: 'post'
  },

  mfaCreateAuthenticator: {
    apiTarget: API_TARGET_AUTH,
    url: '/mfa/methods',
    method: 'post'
  },

  mfaDeleteUserAuthenticator: {
    apiTarget: API_TARGET_AUTH,
    url: '/mfa/methods/:id',
    method: 'delete'
  },

  mfaSaveAuthenticator: {
    apiTarget: API_TARGET_AUTH,
    url: '/mfa/methods/verify',
    method: 'post'
  },

  mfaSendOtp: {
    apiTarget: API_TARGET_AUTH,
    url: '/mfa/one_time_passwords/send_otp',
    method: 'post'
  },

  mfaGetAuthenticators: {
    apiTarget: API_TARGET_AUTH,
    url: '/mfa/methods',
    method: 'get'
  },

  mfaUpdateUserSetting: {
    apiTarget: API_TARGET_AUTH,
    url: '/mfa/user_setting',
    method: 'patch'
  },

  mfaVerifyOtp: {
    apiTarget: API_TARGET_AUTH,
    url: '/mfa/one_time_passwords/verify',
    method: 'post',
    transformResponse: res => res.user,
    reducer: {
      name: 'currentUser',
      initialState: {}
    }
  },

  fetchPreferences: {
    apiTarget: API_TARGET_AUTH,
    url: '/preferences',
    method: 'get'
  },

  fetchUserPreferences: {
    apiTarget: API_TARGET_AUTH,
    url: '/user_preferences',
    method: 'get'
  },

  createUserPreference: {
    apiTarget: API_TARGET_AUTH,
    url: '/user_preferences',
    method: 'post'
  },

  deleteUserPreference: {
    apiTarget: API_TARGET_AUTH,
    url: '/user_preferences/:id',
    method: 'delete'
  }
};

export default authRoutes;
